/* src/components/ContactForm/ContactForm.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_render_callback,
	append_hydration,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	destroy_each,
	detach,
	element,
	init,
	insert_hydration,
	listen,
	noop,
	run_all,
	safe_not_equal,
	select_option,
	select_value,
	set_data,
	set_input_value,
	space,
	text
} from "svelte/internal";

import gql from 'nanographql';
import { onMount } from 'svelte';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[19] = list[i];
	return child_ctx;
}

// (72:2) {#if success}
function create_if_block_1(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text("Your message was successfully received.");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, role: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, "Your message was successfully received.");
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "alert alert-success");
			attr(div, "role", "alert");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (76:2) {#each errors as error}
function create_each_block_1(ctx) {
	let div;
	let t_value = /*error*/ ctx[19].message + "";
	let t;

	return {
		c() {
			div = element("div");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, role: true });
			var div_nodes = children(div);
			t = claim_text(div_nodes, t_value);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "alert alert-danger");
			attr(div, "role", "alert");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			append_hydration(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*errors*/ 16 && t_value !== (t_value = /*error*/ ctx[19].message + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (84:6) {#each contactTypes as type}
function create_each_block(ctx) {
	let option;
	let t_value = /*type*/ ctx[7].text + "";
	let t;
	let option_value_value;

	return {
		c() {
			option = element("option");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			option = claim_element(nodes, "OPTION", {});
			var option_nodes = children(option);
			t = claim_text(option_nodes, t_value);
			option_nodes.forEach(detach);
			this.h();
		},
		h() {
			option.__value = option_value_value = /*type*/ ctx[7].val;
			option.value = option.__value;
		},
		m(target, anchor) {
			insert_hydration(target, option, anchor);
			append_hydration(option, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(option);
		}
	};
}

// (108:2) {:else}
function create_else_block(ctx) {
	let button;
	let t;

	return {
		c() {
			button = element("button");
			t = text("Processing");
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, "Processing");
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "class", "btn btn-primary");
		},
		m(target, anchor) {
			insert_hydration(target, button, anchor);
			append_hydration(button, t);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

// (106:2) {#if !isProcessing}
function create_if_block(ctx) {
	let button;
	let t;
	let mounted;
	let dispose;

	return {
		c() {
			button = element("button");
			t = text("Send Message");
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, "Send Message");
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "class", "btn btn-primary");
		},
		m(target, anchor) {
			insert_hydration(target, button, anchor);
			append_hydration(button, t);

			if (!mounted) {
				dispose = listen(button, "click", /*sendMessage*/ ctx[9]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div4;
	let t0;
	let t1;
	let div0;
	let label0;
	let t2;
	let t3;
	let select;
	let option;
	let t4;
	let t5;
	let div1;
	let label1;
	let t6;
	let t7;
	let input0;
	let t8;
	let small0;
	let t9;
	let t10;
	let div2;
	let label2;
	let t11;
	let t12;
	let input1;
	let t13;
	let small1;
	let t14;
	let t15;
	let div3;
	let label3;
	let t16;
	let t17;
	let textarea;
	let t18;
	let div4_class_value;
	let mounted;
	let dispose;
	let if_block0 = /*success*/ ctx[5] && create_if_block_1(ctx);
	let each_value_1 = /*errors*/ ctx[4];
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*contactTypes*/ ctx[8];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	function select_block_type(ctx, dirty) {
		if (!/*isProcessing*/ ctx[6]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block1 = current_block_type(ctx);

	return {
		c() {
			div4 = element("div");
			if (if_block0) if_block0.c();
			t0 = space();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t1 = space();
			div0 = element("div");
			label0 = element("label");
			t2 = text("Type of Contact");
			t3 = space();
			select = element("select");
			option = element("option");
			t4 = text("-- Choose Option --");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t5 = space();
			div1 = element("div");
			label1 = element("label");
			t6 = text("Name");
			t7 = space();
			input0 = element("input");
			t8 = space();
			small0 = element("small");
			t9 = text("What should we call you?");
			t10 = space();
			div2 = element("div");
			label2 = element("label");
			t11 = text("Email address");
			t12 = space();
			input1 = element("input");
			t13 = space();
			small1 = element("small");
			t14 = text("We'll never share your email with anyone else.");
			t15 = space();
			div3 = element("div");
			label3 = element("label");
			t16 = text("Message");
			t17 = space();
			textarea = element("textarea");
			t18 = space();
			if_block1.c();
			this.h();
		},
		l(nodes) {
			div4 = claim_element(nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			if (if_block0) if_block0.l(div4_nodes);
			t0 = claim_space(div4_nodes);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(div4_nodes);
			}

			t1 = claim_space(div4_nodes);
			div0 = claim_element(div4_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			label0 = claim_element(div0_nodes, "LABEL", { for: true, class: true });
			var label0_nodes = children(label0);
			t2 = claim_text(label0_nodes, "Type of Contact");
			label0_nodes.forEach(detach);
			t3 = claim_space(div0_nodes);
			select = claim_element(div0_nodes, "SELECT", { class: true, id: true });
			var select_nodes = children(select);
			option = claim_element(select_nodes, "OPTION", {});
			var option_nodes = children(option);
			t4 = claim_text(option_nodes, "-- Choose Option --");
			option_nodes.forEach(detach);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(select_nodes);
			}

			select_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t5 = claim_space(div4_nodes);
			div1 = claim_element(div4_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			label1 = claim_element(div1_nodes, "LABEL", { for: true, class: true });
			var label1_nodes = children(label1);
			t6 = claim_text(label1_nodes, "Name");
			label1_nodes.forEach(detach);
			t7 = claim_space(div1_nodes);

			input0 = claim_element(div1_nodes, "INPUT", {
				type: true,
				class: true,
				id: true,
				"aria-describedby": true
			});

			t8 = claim_space(div1_nodes);
			small0 = claim_element(div1_nodes, "SMALL", { id: true, class: true });
			var small0_nodes = children(small0);
			t9 = claim_text(small0_nodes, "What should we call you?");
			small0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t10 = claim_space(div4_nodes);
			div2 = claim_element(div4_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			label2 = claim_element(div2_nodes, "LABEL", { for: true, class: true });
			var label2_nodes = children(label2);
			t11 = claim_text(label2_nodes, "Email address");
			label2_nodes.forEach(detach);
			t12 = claim_space(div2_nodes);

			input1 = claim_element(div2_nodes, "INPUT", {
				type: true,
				class: true,
				id: true,
				"aria-describedby": true
			});

			t13 = claim_space(div2_nodes);
			small1 = claim_element(div2_nodes, "SMALL", { id: true, class: true });
			var small1_nodes = children(small1);
			t14 = claim_text(small1_nodes, "We'll never share your email with anyone else.");
			small1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			t15 = claim_space(div4_nodes);
			div3 = claim_element(div4_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			label3 = claim_element(div3_nodes, "LABEL", { for: true, class: true });
			var label3_nodes = children(label3);
			t16 = claim_text(label3_nodes, "Message");
			label3_nodes.forEach(detach);
			t17 = claim_space(div3_nodes);
			textarea = claim_element(div3_nodes, "TEXTAREA", { class: true, id: true, rows: true });
			children(textarea).forEach(detach);
			div3_nodes.forEach(detach);
			t18 = claim_space(div4_nodes);
			if_block1.l(div4_nodes);
			div4_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(label0, "for", "reason");
			attr(label0, "class", "svelte-1i8fw9o");
			option.selected = true;
			option.__value = "-- Choose Option --";
			option.value = option.__value;
			attr(select, "class", "form-select svelte-1i8fw9o");
			attr(select, "id", "reason");
			if (/*type*/ ctx[7] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[10].call(select));
			attr(div0, "class", "form-group svelte-1i8fw9o");
			attr(label1, "for", "name");
			attr(label1, "class", "svelte-1i8fw9o");
			attr(input0, "type", "name");
			attr(input0, "class", "form-control rounded svelte-1i8fw9o");
			attr(input0, "id", "name");
			attr(input0, "aria-describedby", "nameHelp");
			attr(small0, "id", "nameHelp");
			attr(small0, "class", "form-text svelte-1i8fw9o");
			attr(div1, "class", "form-group svelte-1i8fw9o");
			attr(label2, "for", "email");
			attr(label2, "class", "svelte-1i8fw9o");
			attr(input1, "type", "email");
			attr(input1, "class", "form-control rounded svelte-1i8fw9o");
			attr(input1, "id", "email");
			attr(input1, "aria-describedby", "emailHelp");
			attr(small1, "id", "emailHelp");
			attr(small1, "class", "form-text svelte-1i8fw9o");
			attr(div2, "class", "form-group svelte-1i8fw9o");
			attr(label3, "for", "message");
			attr(label3, "class", "svelte-1i8fw9o");
			attr(textarea, "class", "form-control rounded svelte-1i8fw9o");
			attr(textarea, "id", "message");
			attr(textarea, "rows", "3");
			attr(div3, "class", "form-group svelte-1i8fw9o");
			attr(div4, "class", div4_class_value = "contact-form " + /*classes*/ ctx[0] + " svelte-1i8fw9o");
		},
		m(target, anchor) {
			insert_hydration(target, div4, anchor);
			if (if_block0) if_block0.m(div4, null);
			append_hydration(div4, t0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(div4, null);
			}

			append_hydration(div4, t1);
			append_hydration(div4, div0);
			append_hydration(div0, label0);
			append_hydration(label0, t2);
			append_hydration(div0, t3);
			append_hydration(div0, select);
			append_hydration(select, option);
			append_hydration(option, t4);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			select_option(select, /*type*/ ctx[7]);
			append_hydration(div4, t5);
			append_hydration(div4, div1);
			append_hydration(div1, label1);
			append_hydration(label1, t6);
			append_hydration(div1, t7);
			append_hydration(div1, input0);
			set_input_value(input0, /*name*/ ctx[1]);
			append_hydration(div1, t8);
			append_hydration(div1, small0);
			append_hydration(small0, t9);
			append_hydration(div4, t10);
			append_hydration(div4, div2);
			append_hydration(div2, label2);
			append_hydration(label2, t11);
			append_hydration(div2, t12);
			append_hydration(div2, input1);
			set_input_value(input1, /*email*/ ctx[2]);
			append_hydration(div2, t13);
			append_hydration(div2, small1);
			append_hydration(small1, t14);
			append_hydration(div4, t15);
			append_hydration(div4, div3);
			append_hydration(div3, label3);
			append_hydration(label3, t16);
			append_hydration(div3, t17);
			append_hydration(div3, textarea);
			set_input_value(textarea, /*message*/ ctx[3]);
			append_hydration(div4, t18);
			if_block1.m(div4, null);

			if (!mounted) {
				dispose = [
					listen(select, "change", /*select_change_handler*/ ctx[10]),
					listen(input0, "input", /*input0_input_handler*/ ctx[11]),
					listen(input1, "input", /*input1_input_handler*/ ctx[12]),
					listen(textarea, "input", /*textarea_input_handler*/ ctx[13])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*success*/ ctx[5]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(div4, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*errors*/ 16) {
				each_value_1 = /*errors*/ ctx[4];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div4, t1);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*contactTypes*/ 256) {
				each_value = /*contactTypes*/ ctx[8];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*type, contactTypes*/ 384) {
				select_option(select, /*type*/ ctx[7]);
			}

			if (dirty & /*name*/ 2) {
				set_input_value(input0, /*name*/ ctx[1]);
			}

			if (dirty & /*email*/ 4 && input1.value !== /*email*/ ctx[2]) {
				set_input_value(input1, /*email*/ ctx[2]);
			}

			if (dirty & /*message*/ 8) {
				set_input_value(textarea, /*message*/ ctx[3]);
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if_block1.d(1);
				if_block1 = current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div4, null);
				}
			}

			if (dirty & /*classes*/ 1 && div4_class_value !== (div4_class_value = "contact-form " + /*classes*/ ctx[0] + " svelte-1i8fw9o")) {
				attr(div4, "class", div4_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div4);
			if (if_block0) if_block0.d();
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if_block1.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { classes = '' } = $$props;

	const contactForm = gql`
    mutation contactForm($email: String!, $name: String!, $message: String!, $type: String!) {
      contactForm(input: { email: $email, name: $name, message: $message, type: $type }) {
        response: string
      }
    }
  `;

	let name = '',
		email = '',
		message = '',
		type = '',
		errors = [],
		success = false,
		isProcessing = false;

	let contactTypes = [
		{
			val: 'Data Request',
			text: 'Data Request'
		},
		{
			val: 'Question',
			text: 'General Question'
		},
		{ val: 'Love-Note', text: 'Love Note' },
		{
			val: 'Partner',
			text: 'Partnership Request'
		},
		{
			val: 'Feedback',
			text: 'Feedback on Find Energy'
		}
	]; // { val: 'Senior-Living-Provider', text: 'Senior Living Provider' },

	let egKey = '';

	onMount(async () => {
		let egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
	});

	const graphql = getGraphqlClient();

	async function sendMessage() {
		$$invalidate(6, isProcessing = true);
		let r = await graphql(contactForm({ name, email, message, type }), { 'eg-key': egKey });

		if (r.errors) {
			$$invalidate(4, errors = r.errors);
			$$invalidate(6, isProcessing = false);
		}

		if (r.data && r.data.contactForm && r.data.contactForm.response && r.data.contactForm.response === 'SUCCESS') {
			$$invalidate(4, errors = []);
			$$invalidate(5, success = true);
			$$invalidate(6, isProcessing = false);

			setTimeout(
				() => {
					$$invalidate(5, success = false);
				},
				5000
			);

			$$invalidate(1, name = '');
			$$invalidate(2, email = '');
			$$invalidate(3, message = '');
			$$invalidate(7, type = 'Question');
		}
	} // console.log(r);

	function select_change_handler() {
		type = select_value(this);
		$$invalidate(7, type);
		$$invalidate(8, contactTypes);
	}

	function input0_input_handler() {
		name = this.value;
		$$invalidate(1, name);
	}

	function input1_input_handler() {
		email = this.value;
		$$invalidate(2, email);
	}

	function textarea_input_handler() {
		message = this.value;
		$$invalidate(3, message);
	}

	$$self.$$set = $$props => {
		if ('classes' in $$props) $$invalidate(0, classes = $$props.classes);
	};

	return [
		classes,
		name,
		email,
		message,
		errors,
		success,
		isProcessing,
		type,
		contactTypes,
		sendMessage,
		select_change_handler,
		input0_input_handler,
		input1_input_handler,
		textarea_input_handler
	];
}

class ContactForm extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { classes: 0 });
	}
}

export default ContactForm;